import type { ICatalog, ILocalizedText } from '@platform/core/types';
import { groupModules, moduleNav, navGroup } from '@platform/navigation';
import { moduleCount } from '../../shell/moduleCount';
import type { IAreaModule } from './IAreaModule';

/**
 * Модулі напряму (групи верхнього меню) у порядку меню групи в цьому просторі: лише встановлені модулі, що показуються в меню (без ярликів «модуль/тип» —
 * вони належать іншому модулю); опис — опис модуля (describe, як mm.desc прототипу v4), без нього — гасло каталогу. Невідома група — порожньо.
 */
export function areaModules(catalog: ICatalog | undefined, groupKey: string, label: (t: ILocalizedText | null | undefined) => string,
  describe?: (key: string) => string, parliament = true): IAreaModule[] {
  const group = navGroup(groupKey);
  if (!group || !catalog) return [];
  return groupModules(group, parliament).filter((k) => !k.includes('/')).flatMap((key) => {
    const m = catalog.modules.find((x) => x.key === key && x.installed);
    return m && moduleNav(key).listed ? [{ key, name: label(m.name), description: describe?.(key) || label(m.tagline), total: moduleCount(m) ?? 0 }] : [];
  });
}
